var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Star 2",
    filter: "url(#filter0_f_1730_7136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9965 7.5035L21.0049 18.6155L33.4965 12.9965L22.3844 21.0049L28.0035 33.4965L19.9951 22.3844L7.50352 28.0035L18.6156 19.995L12.9965 7.5035Z",
    fill: "white",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    id: "Star 3",
    d: "M13.7689 8.83992L20.7448 19.5896L32.1609 13.768L21.4112 20.7439L27.2328 32.16L20.2569 21.4103L8.84081 27.2319L19.5905 20.256L13.7689 8.83992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 408",
    filter: "url(#filter1_f_1730_7136)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.5022,
    cy: 20.4997,
    r: 3.94113,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 409",
    filter: "url(#filter2_f_1730_7136)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.6605,
    cy: 20.6561,
    r: 1.43787,
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1730_7136",
    x: 4.21914,
    y: 4.2192,
    width: 32.5617,
    height: 32.5615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.64214,
    result: "effect1_foregroundBlur_1730_7136"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1730_7136",
    x: 13.6853,
    y: 13.6828,
    width: 13.6338,
    height: 13.6337,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.43787,
    result: "effect1_foregroundBlur_1730_7136"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1730_7136",
    x: 18.5037,
    y: 18.4993,
    width: 4.31385,
    height: 4.3136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.359468,
    result: "effect1_foregroundBlur_1730_7136"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.f8021c4f96e105680b0b7c97215915b5.svg";
export { ForwardRef as ReactComponent };